import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import MemberpayList from "../MemberpayList";
import Profile from "../Profile";

function CustomerProfile(){
    const[searchUi,setSearchUi]=useState(false)
    const[searchContent,setSearchContent]=useState('')
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={45}
        childrenPage={<Profile/>}/>
        </DataContext.Provider>
    )
}

export default CustomerProfile;